<div class="loader-container">
  @if (!hideSpinner) {
<mat-spinner [ngStyle]="{left: leftPosition ?? '50%'}"></mat-spinner>
}
</div>